/*
line items Properties : _gwpType
  - threshold
  - collection
  - choose_gift
  - auto
*/

let isCartUpdating = false;

function getCheckoutButtons() {
  return document.querySelectorAll(
    '[name="checkout"], [data-checkout-button], .cart__checkout, .cart__checkout-button, button[type="submit"][name="checkout"]'
  );
}

function setCartUpdating(active) {
  isCartUpdating = active;

  getCheckoutButtons().forEach((btn) => {
    if (!(btn instanceof HTMLButtonElement || btn instanceof HTMLInputElement)) {
      return;
    }

    btn.disabled = active;
    btn.setAttribute('aria-disabled', active ? 'true' : 'false');

    if (active) {
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('is-cart-loading');
    } else {
      btn.removeAttribute('aria-busy');
      btn.classList.remove('is-cart-loading');
    }
  });
}

document.addEventListener(
  'click',
  (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const checkoutButton = target.closest(
      '[name="checkout"], [data-checkout-button], .cart__checkout, .cart__checkout-button, button[type="submit"][name="checkout"]'
    );

    if (checkoutButton && isCartUpdating) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      console.warn('Checkout blocked while cart is updating');
    }
  },
  true
);

document.addEventListener("customAddToCart", () => {
  const cartFunc = new CartFunc();
  cartFunc.init();
});

document.addEventListener("DOMContentLoaded", () => {
  const cartFunc = new CartFunc();
  cartFunc.init();
});

class CartFunc {
  cart = null;
  gwpSettings = window.gwpSettings || {};
  porductsToAdd = [];
  productsToRemove = [];
  GiftPopup = document.getElementById("GiftPopup");

  constructor() {
    console.log("CartFunc initialized");
  }

  async loadCart() {
    const res = await fetch("/cart.js", {
      headers: {
        Accept: "application/json",
      },
    });
    this.cart = await res.json();
    return this.cart;
  }

  async init() {
    setCartUpdating(true);
    try {
      await this.loadCart();
      await this.runGiftFunctionality();
      await this.refreshCartUI();
    } catch (error) {
      console.error("CartFunc init error:", error);
    } finally {
      setCartUpdating(false);
    }
  }

  async runGiftFunctionality() {
    if (!this.cart) await this.loadCart();

    if (this.gwpSettings.GWP_Enabled) {
      if (this.gwpSettings.GWP_Threshold_Enabled) {
        console.log("Running GWP Threshold Check");
        this.runGWP_Threshold();
      } else {
        this.remove_gifts("threshold");
      }

      if (this.gwpSettings.GWP_Auto_Enabled) {
        console.log("Running GWP Auto Check");
        this.run_gwap();
      } else {
        this.remove_gifts("auto");
      }

      if (this.gwpSettings.GWP_Collection_Enabled) {
        console.log("Running GWP Collection Check");
        this.run_gwcp();
      } else {
        this.remove_gifts("collection");
      }

      if (this.gwpSettings.GWP_Product_Enabled) {
        console.log("Running GWP Product Check");
        this.run_gwp();
      } else {
        this.remove_gifts("product");
      }
    }

    if (
      this.gwpSettings.GWP_enable_gift_popup &&
      this.gwpSettings.GWP_gift_popup_threshold
    ) {
      console.log("Running GWP Choose Gift Check");
      this.run_gwp_choose_gift();
    }

    if (this.porductsToAdd.length > 0) {
      console.info("Adding items to cart", this.porductsToAdd);
      await this.addItemsToCart();
    }

    if (this.productsToRemove.length > 0) {
      console.info("Removing items from cart", this.productsToRemove);
      await this.removeItemsFromCart();
    }
  }

  runGWP_Threshold() {
    const thresholds = this.gwpSettings.GWP_Thresholds || [];
    if (thresholds.length === 0) return;

    const cartTotal = this.cart.total_price / 100;
    const activeThreshold = thresholds
      .filter((tier) => cartTotal >= tier.threshold)
      .sort((a, b) => b.threshold - a.threshold)[0];

    console.log("Active GWP Threshold:", activeThreshold);

    const activeGiftIds = activeThreshold
      ? activeThreshold.gifts.map((g) => g.id)
      : [];

    if (activeThreshold) {
      activeGiftIds.forEach((giftId) => {
        const giftInCart = this.cart.items.some(
          (item) =>
            item.id === giftId && item.properties?._gwpType === "threshold"
        );

        if (!giftInCart) {
          this.porductsToAdd.push({
            id: giftId,
            quantity: 1,
            properties: {
              _gwpType: "threshold",
              _gwpThreshold: activeThreshold.threshold,
              _gwpId: Date.now(),
            },
          });
        }
      });
    }

    this.cart.items
      .filter((item) => item.properties?._gwpType === "threshold")
      .forEach((item) => {
        const giftStillValid = activeGiftIds.includes(item.id);
        if (!giftStillValid) {
          this.productsToRemove.push(item.key);
        }
      });
  }

  remove_gifts(type) {
    this.cart.items
      .filter((item) => item.properties?._gwpType === type)
      .forEach((item) => {
        this.productsToRemove.push(item.key);
      });
  }

  run_gwap() {
    console.log("running gift with any purchase check");

    const giftId = this.gwpSettings.GWP_Auto_Product_gift?.id;
    if (!giftId) return;

    const giftInCart = this.cart.items.some(
      (item) => item.id === giftId && item.properties?._gwpType === "auto"
    );

    const hasRealProduct = this.cart.items.some(
      (item) => item.handle !== "giftcard" && !item.properties?._gwpType
    );

    if (hasRealProduct && !giftInCart) {
      this.porductsToAdd.push({
        id: giftId,
        quantity: 1,
        properties: {
          _gwpType: "auto",
          _gwpId: Date.now(),
        },
      });
    }

    if (!hasRealProduct && giftInCart) {
      const giftItem = this.cart.items.find(
        (item) => item.id === giftId && item.properties?._gwpType === "auto"
      );
      if (giftItem) {
        this.productsToRemove.push(giftItem.key);
      }
    }
  }

  run_gwp() {
    const targetVariants = this.gwpSettings.GWP_Product_Target?.variants || [];
    const giftId = this.gwpSettings.GWP_Product_Gift?.id;
    if (!giftId || targetVariants.length === 0) return;

    const productInCart = this.cart.items.some((item) =>
      targetVariants.includes(item.variant_id)
    );

    const giftInCart = this.cart.items.some(
      (item) => item.id === giftId && item.properties?._gwpType === "product"
    );

    if (productInCart && !giftInCart) {
      this.porductsToAdd.push({
        id: giftId,
        quantity: 1,
        properties: {
          _gwpType: "product",
          _gwpId: Date.now(),
        },
      });
    }

    if (!productInCart && giftInCart) {
      const giftItem = this.cart.items.find(
        (item) => item.id === giftId && item.properties?._gwpType === "product"
      );
      if (giftItem) {
        this.productsToRemove.push(giftItem.key);
      }
    }
  }

  run_gwcp() {
    const targetVariants =
      this.gwpSettings.GWP_Collection_Target?.variants || [];
    const giftId = this.gwpSettings.GWP_Collection_Gift?.id;
    if (!giftId || targetVariants.length === 0) return;

    const productInCart = this.cart.items.some((item) =>
      targetVariants.includes(item.id)
    );

    const giftInCart = this.cart.items.some(
      (item) => item.id === giftId && item.properties?._gwpType === "collection"
    );

    if (productInCart && !giftInCart) {
      this.porductsToAdd.push({
        id: giftId,
        quantity: 1,
        properties: {
          _gwpType: "collection",
          _gwpId: Date.now(),
        },
      });
    }

    if (!productInCart && giftInCart) {
      const giftItem = this.cart.items.find(
        (item) =>
          item.id === giftId && item.properties?._gwpType === "collection"
      );
      if (giftItem) {
        this.productsToRemove.push(giftItem.key);
      }
    }
  }

  run_gwp_choose_gift() {
    const cartTotal = this.cart.total_price / 100;
    const threshold = this.gwpSettings.GWP_gift_popup_threshold;
    const giftOptions = this.gwpSettings.popup_gifts || [];

    const existingGift = this.cart.items.find(
      (item) => item.properties?._gwpType === "choose_gift"
    );

    if (cartTotal >= threshold) {
      if (!existingGift && giftOptions.length > 0) {
        const popup = document.getElementById("GiftPopup");
        if (popup && typeof popup.openWithGifts === "function") {
          popup.openWithGifts();
        }
      }
    } else {
      if (existingGift) {
        this.productsToRemove.push(existingGift.key);
      }
    }
  }

  async addItemsToCart() {
    if (this.porductsToAdd.length === 0) return;

    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        items: this.porductsToAdd,
      }),
    });

    if (res.ok) {
      this.porductsToAdd = [];
      await this.loadCart();

      if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-func",
          cartData: this.cart,
        });
      }
    } else {
      console.error("Failed to add items to cart");
    }
  }

  async removeItemsFromCart() {
    if (this.productsToRemove.length === 0) return;

    const updates = {};
    this.productsToRemove.forEach((key) => {
      updates[key] = 0;
    });

    const res = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        updates: updates,
      }),
    });

    if (res.ok) {
      this.productsToRemove = [];
      await this.loadCart();

      if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-func",
          cartData: this.cart,
        });
      }
    } else {
      console.error("Failed to remove items from cart");
    }
  }

  async refreshCartUI() {
    if (!this.cart) {
      await this.loadCart();
    }

    const cartDrawer = document.querySelector('cart-drawer');
    if (
      cartDrawer &&
      typeof cartDrawer.getSectionsToRender === 'function' &&
      typeof cartDrawer.renderContents === 'function'
    ) {
      try {
        const sectionsToRender = cartDrawer.getSectionsToRender();
        const sectionIds = sectionsToRender.map((section) => section.id);

        const url = `${window.location.pathname}?sections=${sectionIds.join(',')}`;
        const response = await fetch(url, {
          headers: {
            Accept: 'application/json',
          },
        });

        if (response.ok) {
          const sections = await response.json();

          cartDrawer.renderContents({
            id: this.cart.items?.[0]?.id,
            sections,
          }, false);
        }
      } catch (error) {
        console.error('Failed to refresh cart drawer sections', error);
      }
    }

    document.dispatchEvent(
      new CustomEvent("cart:refresh", {
        detail: {
          source: "cart-func",
          cart: this.cart,
        },
      })
    );

    window.dispatchEvent(
      new CustomEvent("cart:refresh", {
        detail: {
          source: "cart-func",
          cart: this.cart,
        },
      })
    );
  }
}

class GiftPopup extends HTMLElement {
  constructor() {
    super();
    this.closeBtn = this.querySelector(".gift-popup__close");
    this.optionsWrapper = this.querySelector(".gift-popup__options");

    if (this.closeBtn) {
      this.closeBtn.addEventListener("click", () => this.close());
    }
  }

  openWithGifts() {
    this.classList.add("is-open");
  }

  close() {
    this.classList.remove("is-open");
  }
}

customElements.define("gift-popup", GiftPopup);
